import { render } from "./TraitementResiliationPage.vue?vue&type=template&id=0e331093&ts=true"
import script from "./TraitementResiliationPage.vue?vue&type=script&lang=ts"
export * from "./TraitementResiliationPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__